/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { FormControl, InputLabel, Select, MenuItem, TextField, CircularProgress } from '@mui/material'; // Added CircularProgress
import Departments from '../Departments';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import axios from 'axios';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function BookAppointmentDialog({ open, onClose }) {
  const navigate = useNavigate();
  const initialFormData = {
    patientName: '',
    email: '',
    mobile: '',
    department: '',
    appointMentdate: '',
    mode: '',
    pageUrl: window.location.href
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setFormData(initialFormData);
      setErrors({});
      setLoading(false);
    }
  }, [open]);

  const allDepartments = [...Departments.medical, ...Departments.surgical];

  const validateForm = () => {
    const newErrors = {}

    if (!formData.patientName)
      newErrors.patientName = 'Please enter patient name.'

    if (!formData.department)
      newErrors.department = 'Please select a department.'

    if (!formData.mobile) {
      newErrors.mobile = 'Please enter a mobile number.'
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = 'Mobile number should be 10 digits.'
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.'
    }

    if (!formData.appointMentdate) {
      newErrors.appointMentdate = 'Please select a date.'
    }

    if (!formData.mode) {
      newErrors.mode = 'Please select a mode.'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'mobile') {
      const numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const isValid = validateForm();
    if (!isValid) return;

    try {
      setLoading(true);

      const formattedDate = formData.appointMentdate
        ? format(formData.appointMentdate, 'yyyy-MM-dd')
        : '';

      const payload = {
        Subject: 'Lead From MagnAid Website',
        Data: {
          ...formData,
          appointMentdate: formattedDate,
        },
      };
      const response = await axios.post(
        'https://maxaidapi.azurewebsites.net/api/EmailApi',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            code: 'ejJkX3l8qSvgulht0AFLPDySiepq0di50UeRGPa4r5VBAzFudFpISA==',
          },
        }
      );
      const dataMessage = response.data;
      if (dataMessage.status === 'Success') {
        setFormData(initialFormData);
        onClose()
        navigate('/thank-you');
      } else {
        toast.error('Something went wrong', dataMessage.message);
      }
    } catch (error) {
      console.error(' Failed to send email:', error.response?.data || error.message);
      toast.error(
        'Failed to send email',
        error.response?.data || error.message,
        { style: { color: 'black' } }
      );
    } finally {
      setLoading(false);
    }
  };
  const inputStyle2 = {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'transparent', // remove full border
        borderBottomColor: '#00a6a2', // apply only bottom border
        borderWidth: '0 0 2px 0', // only bottom
      },
      '& fieldset': {
        borderColor: 'transparent', // remove all borders by default
        borderBottom: '1px solid #ccc', // normal bottom border
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#f28c38',
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: '#0d7878',
      opacity: 1,
    },
  };
  // Define the input style with thickGreen border, orange label, and paraGreen placeholder
  const inputStyle = {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#00a6a2 !important', // thickGreen border on focus
        BorderBottom: '0px !important',
      },
    },
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: '#f28c38 !important', // Orange label on focus with higher specificity
      },
    },
    '& .MuiInputBase-input': {
      '&::placeholder': {
        color: '#0d7878', // paraGreen placeholder color
        opacity: 1,       // Ensure full opacity
      },
    },
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        sx: {
          borderRadius: '24px',
          padding: '20px',
        },
      }}
    >
      <DialogTitle className="text-orange font-heading text-center" sx={{ fontWeight: '700', fontFamily: "Cormorant", fontSize: '24px' }}>
        Book an Appointment
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          className="font-body text-center"
          sx={{ color: '#0d7878', paddingBottom: '20px', fontFamily: "Work Sans" }}
        >
          Please fill out the form below to schedule your appointment.
        </DialogContentText>
        {/* {errors.submit && (
          <p className="text-red-500 text-sm mb-4">{errors.submit}</p>
        )} */}
        <form className="space-y-4 mt-4">
          <TextField
            fullWidth
            label="Name"
            name="patientName"
            value={formData.patientName}
            onChange={handleChange}
            error={!!errors.patientName}
            helperText={errors.patientName}
            sx={inputStyle}
            placeholder="Enter your name"
          />

          <TextField
            fullWidth
            label="Email Address"
            name="email"
            type="email" disabled={loading}
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
            sx={inputStyle}
            placeholder="Enter your email"
          />

          <TextField
            fullWidth
            label="Mobile Number"
            name="mobile"
            type="tel"
            value={formData.mobile}
            onChange={handleChange}
            error={!!errors.mobile}
            helperText={errors.mobile}
            inputProps={{
              maxLength: 10,
              pattern: '[0-9]*',
            }}
            sx={inputStyle}
            placeholder="Enter your mobile"
          />

          <FormControl fullWidth error={!!errors.department}>
            <InputLabel id="department-label">Select Department</InputLabel>
            <Select
              labelId="department-label"
              name="department"
              value={formData.department}
              label="Select Department"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxHeight: '300px',
                    overflowY: 'scroll',
                  },
                },
              }}
              sx={inputStyle}
            >
              {allDepartments.map((dept) => (
                <MenuItem key={dept.title} value={dept.title}>
                  {dept.title}
                </MenuItem>
              ))}
            </Select>
            {errors.department && <p className="text-[#d32f2f] text-[0.75rem] font-body font-semibold">{errors.department}</p>}
          </FormControl>
          <div className='flex md:flex-row flex-col'>
            <div className='w-full md:w-1/2'>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    minDate={new Date()}
                    value={formData.appointMentdate}
                    onChange={(newValue) =>
                      setFormData(prev => ({ ...prev, appointMentdate: newValue }))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={!!errors.appointMentdate}
                        helperText={errors.appointMentdate}
                        sx={inputStyle2}
                        fullWidth
                      />
                    )}
                  />

                </DemoContainer>
              </LocalizationProvider>
              {errors.appointMentdate && (
                <p className='text-[#d32f2f] text-[0.75rem] font-body font-semibold'>
                  {errors.appointMentdate}
                </p>
              )}
            </div>
            <div className='w-full md:w-1/2  py-3 px-5'>
              <FormControl error={!!errors.mode}>
                <FormLabel id="demo-row-radio-buttons-group-label">Mode</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="mode"
                  value={formData.mode}
                  onChange={handleChange}
                >
                  <FormControlLabel value="online" control={<Radio />} label="Online" />
                  <FormControlLabel value="in-person" control={<Radio />} label="In-Person" />
                </RadioGroup>
                {errors.mode && (
                  <p className='MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-21bjyy-MuiFormHelperText-root'>
                    {errors.mode}
                  </p>
                )}
              </FormControl>

            </div>
          </div>

        </form>
      </DialogContent>
      <DialogActions sx={{

      }}>
        <div className='w-1/2 md:w-[30%]  flex justify-center items-center'>
          <Button className='mt-8' onClick={onClose} sx={{ color: '#00a6a2', fontWeight: '500' }} disabled={loading}>
            Cancel
          </Button>

        </div>
        <div className='w-1/2 md:w-[30%] flex justify-center items-center'>
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading} // Disable button while loading
            className={`bg-orange text-white  px-6 py-4 rounded-full font-medium  font-body text-[20px] leading-[1.112em] 
          transition-all duration-300 hover:bg-lightGreen hover:bg-opacity-90 
          hover:translate-y-[-3px]  md:inline-block text-center mr-[0] md:mr-[24px] mt-8 lg:mt-0 flex items-center justify-center ${loading ? 'opacity-70 cursor-not-allowed' : ''
              }`}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ color: 'white', marginRight: '8px' }} />
                Sending...
              </>
            ) : (
              'Submit'
            )}
          </button>
        </div>

      </DialogActions>
    </Dialog>
  );
}